(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const iconSrc = 'https://cdn.shopify.com/s/files/1/0644/8650/6562/files/image_63.png?v=1761033041';

    function findAddToCartBtn(scope) {
      return scope.querySelector(
        'button[name="add"], button.add-to-cart, .product-form__submit, [data-add-to-cart], [data-product-atc]'
      );
    }

    async function ajaxAddToCart(scope) {
      const variantInput =
        scope.querySelector('input[name="id"][value]') ||
        scope.querySelector('select[name="id"] option[selected]') ||
        scope.querySelector('[data-variant-id]');
      const variantId =
        (variantInput && (variantInput.value || variantInput.getAttribute('data-variant-id'))) ||
        scope.getAttribute('data-variant-id');

      if (!variantId) throw new Error('No variant id found');

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error('Add to cart failed');
      return await res.json();
    }

    document.querySelectorAll('li.product-grid__item').forEach((item) => {
      const infoContainer =
        item.querySelector('.card-information, .card__information, .card__content, .product-card__info, .card-wrapper, .product-grid__card, .card');
      const media = item.querySelector('.card-gallery, .card__media, .media');
      const title = item.querySelector('.product-title, .card__heading, h3, h2');
      const price = item.querySelector('.price, .price-list, [data-price], .card-information__meta, .price__container');
      if (!infoContainer || !title || title.closest('.nn-info-row')) return;

      const row = document.createElement('div');
      row.className = 'nn-info-row';

      const texts = document.createElement('div');
      texts.className = 'nn-texts';

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nn-basket';
      btn.setAttribute('aria-label', 'Add to cart');
      btn.innerHTML = `<img src="${iconSrc}" alt="Add to cart" loading="lazy" decoding="async">`;
// Check if product is sold out and hide button if so
const soldOut = item.querySelector('.badge--sold-out, .sold-out, [data-sold-out], .product--sold-out');
if (soldOut || item.textContent.toLowerCase().includes('sold out')) {
  btn.style.display = 'none';
}


      texts.appendChild(title);
    

      row.appendChild(texts);
      row.appendChild(btn);

      if (media && media.parentElement) {
        media.parentElement.insertBefore(row, media.nextSibling);
      } else {
        infoContainer.appendChild(row);
      }



      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const scope = e.currentTarget.closest('li.product-grid__item') || document;
        const atc = findAddToCartBtn(scope) || findAddToCartBtn(infoContainer) || findAddToCartBtn(document);
        if (atc) {
          atc.click();
          btn.classList.add('nn-basket--added');
          setTimeout(() => btn.classList.remove('nn-basket--added'), 1200);
          return;
        }
        try {
          await ajaxAddToCart(scope);
          btn.classList.add('nn-basket--added');
          setTimeout(() => btn.classList.remove('nn-basket--added'), 1200);
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
        } catch (err) {
          btn.classList.add('nn-basket--error');
          setTimeout(() => btn.classList.remove('nn-basket--error'), 1200);
          console.error(err);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
